import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"
function fastrisTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms & Conditions FastRIS App</h4>
            <br />
            <ul>
              <li>THE DEVELOPER = MWX Apps</li>
              <li>THE APP = FastRIS</li>
            </ul>
            <br />
            <p>
              By downloading or using THE APP, these terms will automatically apply
              to you – you should make sure therefore that you read them carefully
              before using THE APP. You're not allowed to copy, or modify THE APP,
              any part of THE APP, or our trademarks in any way. You're not allowed
              to attempt to extract the source code of THE APP, and you also
              shouldn't try to translate THE APP into other languages, or make
              derivative versions. THE APP itself, and all the trade marks,
              copyright, database rights and other intellectual property rights
              related to it, still belong to THE DEVELOPER.
            </p>
            <p>
              THE DEVELOPER is committed to ensuring that THE APP is as useful and
              efficient as possible. For that reason, we reserve the right to make
              changes to THE APP or to charge for its services, at any time and for
              any reason. We will never charge you for THE APP or its services
              without making it very clear to you exactly what you're paying for.
            </p>
            <p>
              THE APP stores and processes personal data that you have provided to
              us, in order to provide its service. It's your responsibility to keep
              your phone and access to THE APP secure. We therefore recommend that
              you do not jailbreak or root your phone, which is the process of
              removing software restrictions and limitations imposed by the official
              operating system of your device. It could make your phone vulnerable to
              malware/viruses/malicious programs, compromise your phone's security
              features and, it could mean that THE APP won't work properly or at all.
            </p>
            <p>
              You should be aware there are certain things that THE DEVELOPER will
              not take responsibility for. Certain functions of THE APP will require
              THE APP to have an active internet connection. The connection can be
              Wi-Fi, or provided by your mobile network provider, but THE DEVELOPER
              cannot take responsibility for THE APP not working at full
              functionality if you don't have access to Wi-Fi, and you don't have any
              of your data allowance left.
            </p>
            <p>
              If you're using THE APP outside of an area with Wi-Fi, you should
              remember that your terms of the agreement with your mobile network
              provider will still apply. As a result, you may be charged by your
              mobile provider for the cost of data for the duration of the connection
              while accessing THE APP, or other third party charges. In using THE
              APP, you're accepting responsibility for any such charges, including
              roaming data charges if you use THE APP outside of your home territory
              (i.e. region or country) without turning off data roaming. If you are
              not the bill payer for the device on which you're using THE APP, please
              be aware we assume that you have received permission from the bill
              payer for using THE APP.
            </p>
            <p>
              Along the same lines, THE DEVELOPER cannot always take responsibility
              for the way you use THE APP i.e. You need to make sure your device
              stays charged – if it runs out of battery and, you can't turn it on to
              avail the Service, THE DEVELOPER cannot accept responsibility.
            </p>
            <p>
              With respect to THE DEVELOPER's responsibility for your use of THE APP,
              when you're using THE APP, it's important to bear in mind that although
              we endeavour to ensure that it is updated and correct at all times, we
              do rely on third parties to provide information to us so that we can
              make it available to you. THE DEVELOPER accepts no liability for any
              loss, direct or indirect, you experience as a result of relying wholly
              on this functionality of THE APP.
            </p>
            <p>
              At some point, we may wish to update THE APP. THE APP is currently
              available on Android – the requirements for system(and for any
              additional systems we decide to extend the availability of THE APP to)
              may change, and you'll need to download the updates if you want to keep
              using THE APP. THE DEVELOPER does not promise that it will always
              update THE APP so that it is relevant to you and/or works with the
              Android version that you have installed on your device. However, you
              promise to always accept updates to THE APPlication when offered to
              you, We may also wish to stop providing THE APP, and may terminate use
              of it at any time without giving notice of termination to you. Unless
              we tell you otherwise, upon any termination, (a) the rights and
              licenses granted to you in these terms will end; (b) you must stop
              using THE APP, and (if needed) delete it from your device.
            </p>
            <br />
            <strong id="changes-to-these-terms-and-conditions">
              <a
                aria-hidden="true"
                href="#changes-to-these-terms-and-conditions"
                tabindex="-1"
              >
                <span class="icon icon-link"></span>
              </a>
              Changes to These Terms and Conditions
            </strong>
            <p>
              We may update our Terms and Conditions from time to time. Thus, you are
              advised to review this page periodically for any changes. These changes
              are effective immediately after they are posted on this page.
            </p>
            <br />
            <strong id="contact-us">
              <a aria-hidden="true" href="#contact-us" tabindex="-1">
                <span class="icon icon-link"></span>
              </a>
              Contact Us
            </strong>
            <p>
              If you have any questions or suggestions about this Terms and
              Conditions, do not hesitate to contact us. E-mail: web-developer [at]
              outlook.com
            </p>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default fastrisTerms
